import { render, staticRenderFns } from "./ImagesCards.vue?vue&type=template&id=c1aff8a0&scoped=true&"
import script from "./ImagesCards.vue?vue&type=script&lang=js&"
export * from "./ImagesCards.vue?vue&type=script&lang=js&"
import style0 from "./ImagesCards.vue?vue&type=style&index=0&id=c1aff8a0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1aff8a0",
  null
  
)

export default component.exports